module.exports = __webpack_public_path__ + "783d417d79c105a7b472ef89127955d7.png";